import { FunctionComponent, useMemo } from 'react';
import { Tooltip } from '../../../../../Tooltip';
import { MultipleDaysText } from '../MultipleDatesText';
import styles from '../styles.module.scss';
import { timeFormatOptions } from '../../../../../../services/dateFormats';
import { Temporal } from 'temporal-polyfill';
import { TimezoneDate } from '../../../../../TimezoneDate';

type DateTextProps = {
    startDate: Temporal.ZonedDateTime;
    endDate: Temporal.ZonedDateTime;
    doesSpanMultipleDays: boolean;
};

const dateLabelOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
} as const;

const Weekday: FunctionComponent<{ date: Temporal.ZonedDateTime }> = ({ date }) => {
    return <TimezoneDate date={date} format={dateLabelOptions} />;
};

export const DateText: FunctionComponent<DateTextProps> = ({
    startDate,
    endDate,
    doesSpanMultipleDays,
}) => {
    const timezone = useMemo(() => {
        return startDate.timeZoneId;
    }, [startDate]);

    if (doesSpanMultipleDays) {
        return <MultipleDaysText startDate={startDate} endDate={endDate} />;
    }

    return (
        <Tooltip tooltip={timezone}>
            <div className={styles.dateText} role="textbox" aria-label="Single day text">
                <Weekday date={startDate} /> ,{' '}
                <TimezoneDate date={startDate} format={timeFormatOptions} />
                <span aria-hidden="true"> → </span>
                <span className="screen_reader_hidden"> to </span>
                <TimezoneDate
                    date={endDate}
                    format={{
                        hour: 'numeric',
                        minute: 'numeric',
                        timeZoneName: 'short',
                    }}
                />
            </div>
        </Tooltip>
    );
};
